import {
  Button,
  ErrorContent,
  Modal,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalManager,
} from "../../../../components";
import React from "react";
import { useResultTranslation } from "./hooks";

export type ResultData = {
  status: string;
  result?: string | undefined | null;
  errorCode?: string | undefined | null;
};

type Props = {
  show: boolean;
  onClose: () => any;
  result: ResultData;
  onBtnClick: () => any;
};

export const ResultModal = ({ show, onClose, result, onBtnClick }: Props) => {
  const { image, title, description, buttonText } = useResultTranslation(
    result,
    null
  );

  return (
    <ModalManager onClose={onClose} showModal={show}>
      <Modal wrapContent={true}>
        <ModalHeader />
        <ModalContent>
          <ErrorContent image={image} title={title} description={description} />
        </ModalContent>
        <ModalFooter>
          <Button onClick={onBtnClick} width100>
            {buttonText}
          </Button>
        </ModalFooter>
      </Modal>
    </ModalManager>
  );
};
